import { render, staticRenderFns } from "./inspectionCountByUnitDetails.vue?vue&type=template&id=597c124f&"
import script from "./inspectionCountByUnitDetails.vue?vue&type=script&lang=js&"
export * from "./inspectionCountByUnitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports